import { Component } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'pd-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss']
})
export class FooterComponent {
  constructor(private router: Router) { }
  goToPage(name: string) {
    this.router.navigate([`/layouts/${name}`]);
  }
}
